import { OptionType } from '@components/select/dist/types';
import { makeAutoObservable } from 'mobx';

import { extraParams, reverseParams } from 'constants/extraParams';
import { TADR } from 'store/FilterStore/types';
import { RootStore } from 'store/RootStore';
import { MultiSelectChangeData } from 'types/@components/common';

class ADR {
  selectedOptions: OptionType[];
  root: RootStore;

  constructor(root: RootStore) {
    this.root = root;
    this.selectedOptions = [];

    makeAutoObservable(this);
  }

  get hasSelectedOption() {
    return this.selectedOptions.length;
  }

  get isAllOptionsSelected() {
    const allOptionsLength = this.root.options.getADRTypes().length;
    const selectedOptionsLength = this.selectedOptions.length;

    return allOptionsLength === selectedOptionsLength;
  }

  get selectedIds() {
    return this.isAllOptionsSelected
      ? null
      : this.selectedOptions.filter(option => option.value).map(option => option.value as number);
  }

  get requestData(): TADR {
    const reverse = this.root.filter?.extraParams.reverse;

    if (reverse?.isEnabled && reverse.isExcluded(reverseParams.adr)) {
      return { type: 'exclude' };
    }

    if (!this.root.filter?.extraParams.withADR) {
      return null;
    }

    return {
      type: 'include',
      ...(this.hasSelectedOption && { ids: this.selectedIds }),
    };
  }

  setADR = (adr: { type: 'include'; ids?: number[] }) => {
    this.root.filter.extraParams.addParam(extraParams.withAdr);
    this.selectOptionsByIds(adr.ids);
  };

  clear = () => {
    if (!this.selectedOptions.length) return;

    this.selectedOptions = [];
  };

  selectOptionsByIds = (ids?: number[]) => {
    const options = this.root.options.getADRTypes();
    const selectedOptions = options.filter(option => ids?.includes(option.value));

    this.selectedOptions = selectedOptions;
  };

  selectOption = (_option: OptionType | null, data: MultiSelectChangeData) => {
    this.selectedOptions = data.array;
  };
}

export { ADR };
